import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Login from "../components/Login/Login";
import HomeDashboardModule from "../modules/CustomDashboardModule/components/dashboard/HomeDashboardModule";
import { StoreModule } from "../modules/StoresModule/Components/StoreComponent/StoreModule";
import { environment } from "../environments/environment";
import { InventoryManagement } from "../modules/StoresModule/Components/InventoryManagementComponent/InventoryManagement";
import { ConfigurationModule } from "../modules/ConfigurationModule/components/ConfigurationModule/ConfigurationModule";
import { PartsConfiguration } from "../modules/ConfigurationModule/components/PartsConfiguration/PartsConfiguration";
import { DialogProvider } from "../contexts/DialogContext";
import { ContextMenuProvider } from "../contexts/ContextMenuContext";
import { ContextMenu } from "../components/ContextMenu/ContextMenu";
import { SnackBarProvider } from "../contexts/SnackBarContext";
import { SnackBar } from "../components/SnackBar/SnackBar";
import { PathNotFoundComponent } from "../components/PathNotFoundComponent/PathNotFoundComponent";
import { LocationsConfigurationComponent } from "../modules/ConfigurationModule/components/LocationsConfiguration/LocationsConfigurationComponent";
import { AircraftConfiguration } from "../modules/ConfigurationModule/components/AircraftConfiguration/AircraftConfiguration";
import { SkeletonTheme } from "react-loading-skeleton";
import { PartRequest } from "../modules/StoresModule/Components/PartRequest/PartRequest";
import { Alert } from "../components/Dialog/Alert";
import { NewPartRequest } from "../modules/StoresModule/Components/PartRequest/createNewPartRequest/NewPartRequest";
import { InventoryTransaction } from "../modules/StoresModule/Components/InventoryTransaction/InventoryTransaction";
import { Wrapper } from "../components/Wrapper/Wrapper";
import { AliveScope, KeepAlive } from "react-activation";
import { OrdersManagement } from "../modules/StoresModule/Components/Orders/OrdersManagement";
import { PartRequestManagement } from "../modules/SupplyChainModules/Components/PartRequest/PartRequest";
import { SupplyChainComponent } from "../modules/SupplyChainModules/Components/SupplyChainComponent/SupplyChainComponent";
import RequireAuth from "../services/RequireAuth";
import QuoteTrack from "../modules/SupplyChainModules/Components/QuoteTrack/QuoteTrack";
import { ReceivingManagement } from "../modules/StoresModule/Components/ReceivingManagement/ReceivingManagement";
import { PackageIntake } from "../modules/StoresModule/Components/PackageIntake/PackageIntake";
import { QuoteEntry } from "../modules/VendorModule/Components/QuoteEntry/QuoteEntry";
import VendorAwb from "../modules/VendorModule/Components/VendorAWB/VendorAwb";
import { Discrepancy } from "../modules/SupplyChainModules/Components/Discrepancy/Discrepancy";
import { VendorModule } from "../modules/VendorModule/Components/VendorModule/VendorModule";
import VendorApproval from "../modules/VendorModule/Components/VendorApproval/VendorApproval";
import VendorDiscrepancy from "../modules/VendorModule/Components/VendorDiscrepancy/VendorDiscrepancy";
import EngineeringTask from "../modules/ConfigurationModule/components/EngineeringTask/EngineeringTask";
import { Link } from "@mui/material";
import StoreDashboardModule from "../modules/CustomDashboardModule/components/dashboard/StoreDashboardModule";
import VendorDashboardModule from "../modules/CustomDashboardModule/components/dashboard/VendorDashboardModule";
import ConfigurationDashboardModule from "../modules/CustomDashboardModule/components/dashboard/ConfigurationDashboardModule";
import SupplyChainDashboardModule from "../modules/CustomDashboardModule/components/dashboard/SupplyChainDashboardModule";
const basePath = environment.basePath;
function AppRoutes() {
  const navigate = useNavigate();
  const homeInfo = {
    moduleIcon: "icon-home_icon",
    moduleColor: "#919ce6",
    title: "Home",
    menuTitle: "Home",
    moduleId: 11,
    dataBreadCrumbs: [
      <Link
        key={2}
        underline="none"
        sx={{ color: "#000000", cursor: "auto", fontSize: "var(--p-size)" }}
        onClick={() => navigate("/secure/customdashboard")}
      >
        Home
      </Link>,
    ],
  };

  const configurationInfo = {
    moduleIcon: "icon-settings",
    moduleColor: "#7bb9db",
    title: "Configuration",
    menuTitle: "Configuration",
    moduleId: 1,
    dataBreadCrumbs: "/configuration",
  };

  const storeInfo = {
    moduleIcon: "icon-stores",
    moduleColor: "#eb9090",
    title: "Stores",
    menuTitle: "Stores",
    moduleId: 3,
    dataBreadCrumbs: "/store",
  };

 const supplyChainInfo = {
    moduleIcon: "icon-supply-chain",
    moduleColor: "#F38A00",
    title: "Supply Chain",
    menuTitle: "Supply Chain",
    moduleId: 12,
    dataBreadCrumbs: "/supplychain",
  };
  const vendorInfo = {
        moduleIcon: "icon-business",
    moduleColor: "#E19357",
    title: "Vendor",
    menuTitle: "Vendor",
    moduleId: 13,
    dataBreadCrumbs: "/vendor",
  }
  const location = useLocation();
  const noWrapperPaths = ["/", "/login"];
  const isNotFound =
    location.pathname !== "/" &&
    location.pathname !== "/login" &&
    !location.pathname.startsWith(basePath);
  const shouldWrap = !noWrapperPaths.includes(location.pathname) && !isNotFound;
  const routeToModuleMap = [
    { path: "/store", module: "Stores" },
    { path: "/configuration", module: "Configuration" },
    { path: "/customdashboard", module: "Home" },
    { path: "/supplychain", module: "SupplyChain" },
    { path: "/vendor", module: "Vendor" },
  ];
  const currentModule = routeToModuleMap.find(({ path }) =>
    location.pathname.startsWith(basePath + path)
  )?.module;
  const content = (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />

      {/* custom dashboard path */}
      <Route
        path={basePath}
        element={<HomeDashboardModule navBarInfo={homeInfo} workStream={"home"} />}
      />
      <Route
        path={basePath + "/customdashboard"}
        element={<HomeDashboardModule workStream={"home"} navBarInfo={homeInfo} />}
      />

      {/* stores module paths */}
      <Route
        path={basePath + "/store"}
        element={
          <StoreDashboardModule workStream={"stores"} navBarInfo={storeInfo} />
        }
      />
      <Route
        path={basePath + "/store/inventory-management"}
        element={<InventoryManagement />}
      />
      <Route
        path={basePath + "/store/part-request-management"}
        element={<PartRequest />}
      />
      <Route
        path={basePath + "/store/new-part-request"}
        element={<NewPartRequest />}
      />
      <Route
        path={basePath + "/store/inventory-transaction"}
        element={<InventoryTransaction />}
      />

      <Route
        path={basePath + "/store/receiving"}
        element={<ReceivingManagement />}
      />

      <Route
        path={basePath + "/store/package-intake"}
        element={<PackageIntake />}
      />

      {/* Vendor */}

      <Route
        path={basePath + "/vendor/vendor-approval"}
        element={<VendorApproval />}
      />

      <Route path={basePath + "/vendor/awb"} element={<VendorAwb />} />
      <Route
        path={basePath + "/vendor/discrepancy"}
        element={<VendorDiscrepancy />}
      />
      <Route path={basePath + "/vendor/quote-entry"} element={<QuoteEntry />} />
      {/* Supply chain module paths */}
      <Route
        path={basePath + "/supplychain"}
        element={<SupplyChainDashboardModule workStream={"supplychain"} navBarInfo={supplyChainInfo} />}
      />
      <Route
        path={basePath + "/supplychain/part-request-management"}
        element={<PartRequestManagement />}
      />

      <Route
        path={basePath + "/supplychain/orders-management"}
        element={<OrdersManagement />}
      />
      <Route
        path={basePath + "/supplychain/quote-tracking"}
        element={<QuoteTrack />}
      />

      <Route
        path={basePath + "/supplychain/discrepancy"}
        element={<Discrepancy></Discrepancy>}
      />
      {/* configuration module paths */}

      <Route
        path={basePath + "/configuration"}
        element={
          <ConfigurationDashboardModule
            workStream={"configuration"}
            navBarInfo={configurationInfo}
          />
        }
      />
      <Route
        path={basePath + "/configuration/parts"}
        element={<PartsConfiguration />}
      />
      <Route
        path={basePath + "/configuration/aircraft"}
        element={<AircraftConfiguration />}
      />
      <Route
        path={basePath + "/configuration/locations-configuration"}
        element={<LocationsConfigurationComponent />}
      />
      <Route
        path={basePath + "/configuration/engineering-task"}
        element={<EngineeringTask />}
      />

      {/* Vendor */}
      <Route path={basePath + "/vendor"} element={<VendorDashboardModule workStream={"vendor"} navBarInfo={vendorInfo} />} />

      {/* not found */}
      <Route path="*" element={<PathNotFoundComponent />} />
    </Routes>
  );

  return shouldWrap ? (
    <SkeletonTheme>
      <DialogProvider>
        <ContextMenuProvider>
          <ContextMenu />
          <AliveScope>
            <RequireAuth>
              <Wrapper currentModule={currentModule}>{content}</Wrapper>{" "}
            </RequireAuth>
          </AliveScope>
        </ContextMenuProvider>
      </DialogProvider>
      <SnackBar />
      <Alert />
    </SkeletonTheme>
  ) : (
    <SkeletonTheme>
      <DialogProvider>
        <ContextMenuProvider>
          <ContextMenu />

          {content}
        </ContextMenuProvider>
      </DialogProvider>
      <SnackBar />
      <Alert />
    </SkeletonTheme>
  );
}
export default function RoutesConfig() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
